// removed by extract-text-webpack-plugin
module.exports = {"base":"Back_base--KGDDq","header":"Back_header--1iTDX","scroll":"Back_scroll--QNMhr","scroll__shadows":"Back_scroll__shadows--1kWir","scrollShadows":"Back_scroll__shadows--1kWir","footer":"Back_footer--1VttH","description":"Back_description--2Loc9","noDescription":"Back_noDescription--3g_v7","title":"Back_title--39ocR","clanButton":"Back_clanButton--3LJWq","clanButtonImage":"Back_clanButtonImage--2gJ_t"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Back/Back.scss
// module id = 2252
// module chunks = 11